module.exports = __webpack_public_path__ + "ec1d6c7a97569e9955b93683cb4cede9.svg";